import propTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import { CREDIT_REDEEM_LABEL, GENERIC_FAILURE } from '../../config/text/text';
import { trackEvent } from '../../helpers/analytics';
import ErrorTrackingService from '../../helpers/errorTrackingService';
import ThemeContext from '../../providers/ThemeProvider';
import { updateVoucher } from '../../services/vouchers';
import useToast from '../_generic/toast/UseToast';

const VoucherCreditUnredeems = ({ voucher, mutate }) => {
  const toast = useToast();
  const [disabled, setDisabled] = useState(
    !voucher.businessAcceptsCreditUnredeems || voucher.expired,
  );
  const theme = useContext(ThemeContext);

  const onChange = async () => {
    const updatedValue = !voucher.customerHasChosenCreditUnredeems;
    trackEvent('credit_auto_refund_click');
    setDisabled(true);
    try {
      await updateVoucher(voucher.voucherCode, {
        customerHasChosenCreditUnredeems: updatedValue,
      });
      await mutate();
    } catch (error) {
      toast.addToast(GENERIC_FAILURE);
      ErrorTrackingService.logError(error);
    }
    setDisabled(false);
  };

  return (
    <>
      <div className="credit-unredeems">
        <input
          checked={voucher.customerHasChosenCreditUnredeems}
          disabled={disabled}
          id={`redeem-${voucher.voucherCode}`}
          onChange={onChange}
          type="checkbox"
        />

        <label htmlFor={`redeem-${voucher.voucherCode}`}>
          {CREDIT_REDEEM_LABEL}
          <span>*</span>
        </label>
      </div>
      <style jsx>{`
        .credit-unredeems {
          display: flex;
          padding-top: 20px;
          color: ${theme.colors.socialcuecolor.assure};
        }
        input {
          margin-right: 5px;
          margin-top: 4px;
        }
      `}</style>
    </>
  );
};

VoucherCreditUnredeems.propTypes = {
  mutate: propTypes.func,
  voucher: propTypes.object,
};

export default VoucherCreditUnredeems;
